'use strict';

exports.__esModule = true;
exports.default = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2, _initialiseProps;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Element2 = require('./Element');

var _Element3 = _interopRequireDefault(_Element2);

var _wait = require('./utils/wait');

var _wait2 = _interopRequireDefault(_wait);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Button = (_temp2 = _class = function (_Element) {
  (0, _inherits3.default)(Button, _Element);

  function Button() {
    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Button);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _Element.call.apply(_Element, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  Button.prototype.process = function () {
    var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              throw new Error('You need to implement process');

            case 1:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function process() {
      return _ref.apply(this, arguments);
    }

    return process;
  }();

  Button.prototype.render = function render() {
    var _props = this.props,
        children = _props.children,
        render = _props.render;

    var newProps = {
      onClick: this.onClick
    };

    if (typeof children === 'function') {
      return this.replaceChildren(children(newProps));
    }if (typeof render === 'function') {
      return this.replaceChildren(render(newProps));
    }

    throw new Error('You need to set property render or children as function');
  };

  return Button;
}(_Element3.default), _class.propTypes = {
  render: _propTypes2.default.func,
  text: _propTypes2.default.string,
  children: _propTypes2.default.func
}, _class.defaultProps = {
  text: 'Button'
}, _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.onClick = function () {
    var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      var result, onClick;
      return _regenerator2.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this2.process();

            case 2:
              result = _context2.sent;

              if (!(typeof result === 'undefined')) {
                _context2.next = 5;
                break;
              }

              return _context2.abrupt('return');

            case 5:
              onClick = _this2.props.onClick;

              if (!onClick) {
                _context2.next = 10;
                break;
              }

              _context2.next = 9;
              return (0, _wait2.default)(0);

            case 9:
              onClick.apply(undefined, args.concat([result]));

            case 10:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }));

    return function () {
      return _ref2.apply(this, arguments);
    };
  }();
}, _temp2);
exports.default = Button;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-form-controlled/lib/Button.js
 ** module id = 233
 ** module chunks = 0
 **/